import React, { useEffect } from "react";
import Body from "../components/ui/Body";
import Productcatagories from "../components/ui/Productcatagories";
import Offerproduct from "../components/ui/Offerproduct";
import Ourproduct from "../components/ui/Ourproduct";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../redux/actions/ProductAction";

const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  const products = useSelector((state) => state.product);

  console.log("prprprpr", products);
  return (
    <>
      <Body />
      <Productcatagories />
      <Offerproduct products={products} />
      <Ourproduct products={products} />
    </>
  );
};

export default Home;
